'use client'

import Image from 'next/image'
import '../../sass/landing/Footer.scss'
import { Link } from '@/i18n/routing'
import { useTranslations, useLocale } from 'next-intl'
import useLanguageSwitcher from '../widgets/settings/useLanguageSwitcher'

const LandingFooter = () => {
  const t = useTranslations('LandingFooter')
  const locale = useLocale()
  const { changeLanguage } = useLanguageSwitcher()
  const year = new Date().getFullYear()

  return (
    <footer className='landing-footer'>
      <div className='landing-footer__main'>
        <div className='landing-footer__inner'>
          <div className='landing-footer__brand'>
            <Link href='/' className='landing-footer__logo'>
              <Image
                src='/img/barmanager-logo.svg'
                alt='logo barmanager.app'
                height={200}
                width={600}
              />
            </Link>
            <p className='landing-footer__tagline'>{t('tagline')}</p>
            {/* <div className='landing-footer__badges'>
              <span><span className='landing-footer__dot' /> {t('freePlan')}</span>
              <span><span className='landing-footer__dot' /> {t('cancelAnytime')}</span>
            </div> */}
          </div>

          <div className='landing-footer__columns'>
            <div className='landing-footer__col'>
              <h3>{t('product')}</h3>
              <ul>
                <li><Link href='/#features'>{t('menu')}</Link></li>
                <li><Link href='/#features'>{t('delivery')}</Link></li>
                <li><Link href='/#features'>{t('bookings')}</Link></li>
                <li><Link href='/pricing'>{t('pricing')}</Link></li>
              </ul>
            </div>

            <div className='landing-footer__col'>
              <h3>{t('company')}</h3>
              <ul>
                <li><a href='mailto:info@barmanager.app'>{t('contact')}</a></li>
                <li><Link href='/support'>{t('support')}</Link></li>
                <li><Link prefetch={false} href='/privacy'>{t('privacyPolicy')}</Link></li>
                <li><Link prefetch={false} href='/terms'>{t('terms')}</Link></li>
              </ul>
            </div>

            <div className='landing-footer__col'>
              <h3>{t('resources')}</h3>
              <ul>
                <li><Link href='/blog'>Blog</Link></li>
                <li><Link href='/whats-new'>{t('whatsNew')}</Link></li>
                <li><Link href='/changelog'>{t('changelog')}</Link></li>
                <li><Link href='/support'>{t('helpCenter')}</Link></li>
                <li><Link href='/pricing'>{t('comparePlans')}</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className='landing-footer__bar'>
        <div className='landing-footer__bar-inner'>
          <span className='landing-footer__copyright'>
            © {year} BarManager. {t('footerText2')} <a href='https://domindez.com'>Domindez</a>.
          </span>

          <div className='landing-footer__legal'>
            <Link prefetch={false} href='/privacy'>{t('privacyPolicy')}</Link>
            <span className='landing-footer__legal-sep'>·</span>
            <Link prefetch={false} href='/terms'>{t('terms')}</Link>
          </div>

          <div className='landing-footer__lang'>
            <button
              type='button'
              onClick={() => changeLanguage('es')}
              className={locale === 'es' ? 'is-active' : ''}
              aria-label='Español'
            >
              ES
            </button>
            <span className='landing-footer__lang-sep'>·</span>
            <button
              type='button'
              onClick={() => changeLanguage('en')}
              className={locale === 'en' ? 'is-active' : ''}
              aria-label='English'
            >
              EN
            </button>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default LandingFooter
